import useAddFavoriteDocument from 'domain/documents/hooks/useAddFavoriteDocument';
import useGetFavoriteDocuments from 'domain/documents/hooks/useGetFavoriteDocuments';
import useRemoveFavoriteDocument from 'domain/documents/hooks/useRemoveFavoriteDocument';
import { IndexedItemRef, indexedItemKey } from 'domain/documents/schemas/document';

// Un document est favori ou non selon la liste des favoris, seule source de vérité. Chaque mutation
// invalide cette liste ; tous les cœurs affichés — résultats, suggestions, panneau latéral — se
// remettent d'accord sans qu'aucun composant n'ait à propager l'information à ses voisins.
export default function useFavoriteToggle({ source, entityId }: IndexedItemRef) {
  const { favoriteKeys } = useGetFavoriteDocuments();
  const { mutate: addFavorite, isPending: isAdding } = useAddFavoriteDocument();
  const { mutate: removeFavorite, isPending: isRemoving } = useRemoveFavoriteDocument();

  const isFavorite = favoriteKeys.has(indexedItemKey({ source, entityId }));
  const isPending = isAdding || isRemoving;

  return {
    isFavorite,
    isPending,
    toggle: () => {
      if (isPending) return;
      if (isFavorite) removeFavorite({ source, entityId });
      else addFavorite({ source, entityId });
    },
  };
}
